import { RefundObligationsSection } from "./RefundObligationsSection";
import { StaleMonriPaymentsSection } from "./StaleMonriPaymentsSection";

export function RefundsPage() {
  return (
    <div className="mx-auto max-w-6xl space-y-10 pb-14">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold tracking-tight text-foreground" style={{ fontFamily: "var(--font-heading)" }}>
          Povrati
        </h1>
        <p className="max-w-2xl text-sm text-muted-foreground">
          Platforma nema automatski povrat novca. Ovdje su svi iznosi koje treba vratiti i kartične uplate koje treba
          provjeriti u Monri portalu.
        </p>
      </header>
      <RefundObligationsSection />
      <StaleMonriPaymentsSection />
    </div>
  );
}
